import {
  ApiOffersCommonOfferResponse,
  OffersCommonOfferResponse,
} from '../types/OffersCommonOfferResponse';

const snakeToOfferCamelCase = (
  offer: ApiOffersCommonOfferResponse | null,
): OffersCommonOfferResponse | null => {
  if (!offer) return null;

  return {
    eventSource: offer.event_source,
    eventSavedTimestamp: offer.event_saved_timestamp,
    vendorId: offer.vendor_id,
    cloud: offer.cloud,
    searchTerms: offer.search_terms,
    productId: offer.product_id,
    privateOfferId: offer.private_offer_id,
    offerType: offer.offer_type,
    customerRef: offer.customer_ref,
    offerRef: offer.offer_ref,
    createdAt: offer.created_at,
    sentAt: offer.sent_at,
    viewedOfferAt: offer.viewed_offer_at,
    acceptedAt: offer.accepted_at,
    archivedAt: offer.archived_at,
    cancelledAt: offer.cancelled_at,
    lastModifiedAt: offer.last_modified_at,
    usersToNotify: offer.users_to_notify,
    buyers: offer.buyers,
    status: offer.status,
    company: offer.company,
    azureBillingAccountId: offer.azure_billing_account_id,
    marketplaceFee: offer.marketplace_fee,
    netContractValue: offer.net_contract_value,
    monthlyContractValue: offer.monthly_contract_value,
    totalContractValue: offer.total_contract_value,
    currencyCode: offer.currency_code,
    paymentModel: offer.payment_model,
    billingTerm: offer.billing_term,
    durationValue: offer.duration_value,
    serviceStartAt: offer.service_start_at,
    serviceEndAt: offer.service_end_at,
    allowAutoRenew: offer.allow_auto_renew,
    offerExpirationAt: offer.offer_expiration_at,
    renewal: offer.renewal,
    awsRenewalMovingToMarketplace: offer.aws_renewal_moving_to_marketplace,
    enableZeroDollarPrices: offer.enable_zero_dollar_prices,
    offerStartAt: offer.offer_start_at,
    offerEndAt: offer.offer_end_at,
    marketplaceAcceptanceLink: offer.marketplace_acceptance_link,
    offerPointOfContact: offer.offer_point_of_contact,
    offerPointOfContactName: offer.offer_point_of_contact_name,
    buyerBillingAccountRef: offer.buyer_billing_account_ref,
    salesforceOpportunityId: offer.salesforce_opportunity_id,
    salesforceOpportunityName: offer.salesforce_opportunity_name,
    gsiSalesforceOpportunityId: offer.gsi_salesforce_opportunity_id,
    offerName: offer.offer_name,
    offerDescription: offer.offer_description,
    pricingSchedules: offer.pricing_schedules,
    tackleUrl: offer.tackle_url,
    offerMetadata: offer.offer_metadata, // Preserve internal values
  };
};

export const convertToOffersCamelCase = async (
  offers: ApiOffersCommonOfferResponse[] | null,
): Promise<OffersCommonOfferResponse[] | null> => {
  if (!offers) return null;
  return offers
    .map(snakeToOfferCamelCase)
    .filter((offer): offer is OffersCommonOfferResponse => offer !== null);
};
